export interface IDataNaturezaRendimento {
    codigo: number
    nome: string
}

export const defValueNaturezaRendimento: IDataNaturezaRendimento = {
    codigo: 0,
    nome: ''
}
